<h2 mat-dialog-title class="mb-3">Delete Confirmation</h2>
<mat-dialog-content class="mat-typography">
    <p>Are you sure you want to delete this prompt set?</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close class="cancel-button" (click)="cancel()" [disabled]="isSubmitting">Cancel</button>
    <button mat-raised-button color="primary" (click)="deleteContractCheck()" class="delete-button" [disabled]="isSubmitting">
         Delete
         <mat-spinner *ngIf="isSubmitting" diameter="20" class="button-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>